export const NO_MODULE_ACCESS_TEXT = 'Please contact your company Admin to get access to this module';
export const NO_ACCESS_TEXT = "You don't have access to this. Please contact your company Admin.";
export const NO_BILLING_ACCESS_TEXT = "You don't have access to billing for this company.";
export const NOT_SCHEDULED_FOR_CANCELLATION_TITLE = 'The subscription is not scheduled for cancellation!';
// Billing error titles (detail.title) mapped to what the user should read.
export const BILLING_ERROR_TEXTS: Record<string, { message: string; description?: string }> = {
  'The subscription already exists!': { message: 'This company is already subscribed.' },
  "The subscription hasn't been found!": {
    message: 'Subscribe first',
    description: 'This module needs an active Vyce subscription.',
  },
  'The subscription is not active!': {
    message: 'Subscribe first',
    description: 'This module needs an active Vyce subscription.',
  },
  [NOT_SCHEDULED_FOR_CANCELLATION_TITLE]: { message: 'Your subscription is not set to cancel.' },
};
export const NO_TEAM_CREATION_ACCESS_TEXT = 'Please contact your company Admin to create a Team';

export const cardFromTitle = 'To activate your account, please add your card details...';
export const reactivateCardFromTitle = 'To reactivate your account, please add your card details...';

export const addressFromTitle = 'Almost done!';
